import createCounterInlineFabric from "../../../general/CoreHeader/components/CounterInline/counterInlineFabric";
import { createDisplayNameForHeaderShowAll } from "../../utils/createDisplayName";
import { createTestIdForHeaderShowAll } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderShowAll("CounterInline");
const testId = createTestIdForHeaderShowAll("counter-inline");

const HeaderShowAllCounterInline = createCounterInlineFabric(
    displayName,
    testId,
);

export default HeaderShowAllCounterInline;
